export const errorMessage = (error: any) => {
  const errorPayload = error.payload || error;
  const payloadError = errorPayload.error || errorPayload.message;

  if (payloadError) {
    return payloadError;
  }

  return 'Unknown error';
};
